class Cluster {
    constructor() {
        this.id = null
        this.name = null
        this.description = null
        this.branches_count = null
        this.cluster_type = null
        this.datetime_created = null
        this.datetime_updated = null
    }

    static get fieldNames() {
        return {
            id: 'ID',
            name: 'Nome',
            description: 'Descrição',
            branches_count: 'Filiais',
            cluster_type: 'Tipo',
            datetime_created: 'Data de Criação',
            datetime_updated: 'Data de Atualização'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            name: 'text',
            description: 'text',
            cluster_type: 'number',
            datetime_created: 'datetime-local',
            datetime_updated: 'datetime-local'
        }
    }

    static get visibleFields() {
        return {
            id: false,
            name: true,
            description: true,
            branches_count: true,
            cluster_type: true,
            datetime_created: false,
            datetime_updated: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            name: true,
            description: true,
            branches: true,
            cluster_type: true
            //datetime_created: false
            // datetime_updated: false
        }
    }
}

export default Cluster

export { Cluster }
